import React from 'react';
import { Row, Col } from 'react-bootstrap';
import className from 'classnames';
import PropTypes from 'prop-types';
import Section from 'components/common/Section';
import CardService from './CardService';
import SectionHeader from './SectionHeader';
import is from 'is_js';
import { getConfigFromConfigsByKey } from 'y4/Falcon';
import _ from 'lodash';

const Services = ({ configs }) => {
  if (is.empty(configs)) return null;
  const c = getConfigFromConfigsByKey(configs, 'LandingService');

  const sl = configs
    .filter(p => p.key == 'LandingServiceItem')
    .map(p => {
      return {
        media: _.get(p, 'extension.media'),
        title: p.title,
        description: p.caption
      };
    });

  return (
    <Section bg="light" className="text-center">
      {c && <SectionHeader title={c.title} subtitle={c.caption} />}
      <Row className="mt-6">
        {sl.map((service, index) => (
          <Col
            lg={4}
            className={className({ 'mt-6 mt-lg-0': index > 0 })}
            key={index}
          >
            <CardService {...service} />
          </Col>
        ))}
      </Row>
    </Section>
  );
};
Services.propTypes = {
  configs: PropTypes.array
};
export default Services;
